import { render } from "./JobComment.vue?vue&type=template&id=46eda6b7"
import script from "./JobComment.vue?vue&type=script&lang=js"
export * from "./JobComment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__